module.exports = __webpack_public_path__ + "img/icon_arrow_left_2.cbc40885.svg";